/***
 * Created on 2023/7/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPut} from "../../service/api";
import RemoveContactDialog from "./remove_contact_dialog";
import {useTranslation} from "react-i18next";
import {formatDate, formatTime} from "../../service/datetime";


function ContactRow({fieldList, data}) {
    const [nickName, setNickName] = useState(data?.nickname || data?.email);
    const [showRemoveContact, setShowRemoveContact] = useState(false);
    const queryClient = useQueryClient();
    const editDivRef = useRef();
    const { t } = useTranslation();
    const [editable, setEditable] = useState(false);

    const nicknameMutation = useMutation({
        mutationFn: (data) => apiPut(`/ajax/friend/${data.friend_id}`, {nickname: data.nickname}),
        onError: (error, variables, context) => {
            console.log(error);
        }
    })

    const onContentEditableChange = async (e) => {
        console.log(e.target.innerText);
        if (e.target.innerText !== nickName) {
            if (e.target.innerText.trim() === "") {
                e.target.innerText = nickName;
                return;
            }
            setNickName(e.target.innerText);
            await nicknameMutation.mutateAsync({friend_id: data._id, nickname: e.target.innerText});
        }
        setEditable(false);
    }

    const action = () => {
        setShowRemoveContact(true);
    }

    const onEnterPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    }

    useEffect(()=> {
        editDivRef.current?.addEventListener('onkeypress', onEnterPressed);

        return () => {
            editDivRef.current?.removeEventListener('onkeypress', onEnterPressed);
        }
    });

    return (
        <>
            <div className="flex-table-row">
                <div className={`flex-table__cell flex-table-row__cell w-${fieldList[0].size}`}>
                    <div className="comp-user-info">
                        <div className="comp-avatar no-avatar">
                            <span>G</span>
                            {/*<img src="https://gravatar.com/avatar/ba0a9de012969bf8aab9428430a31f79?s=400&amp;d=retro&amp;r=x" />*/}
                        </div>
                        <div className="user-info-group editable" ref={editDivRef}>
                            <div className={`user-info-group__user-name ${editable ? '' : 'text-ellipsis'}`} contentEditable="plaintext-only"
                                 onFocus={e=> setEditable(true)}
                                 onKeyPress={onEnterPressed}
                                 onBlur={onContentEditableChange} suppressContentEditableWarning={true}>{nickName}</div>
                            <div className="user-info-group__user-mail text-ellipsis">{data.email}</div>
                        </div>
                    </div>
                </div>
                <div className={`flex-table__cell flex-table-row__cell w-${fieldList[1].size}`}>{data.email || data.phone}</div>
                <div className={`flex-table__cell flex-table-row__cell w-${fieldList[2].size}`}>
                    {formatDate(t, data.created_at, true)} {formatTime(data.created_at)}
                </div>
                <div className={`flex-table__cell flex-table-row__cell w-${fieldList[3].size} flex-table__cell--action`} onClick={action}>
                    <div className="util-btn" util-type="remove" img-adj="true" color-scheme="normal"></div>
                </div>
            </div>

            {
                showRemoveContact &&
                <RemoveContactDialog
                    title={t('@Remove from contact list@')} meta={data}
                    showModal={showRemoveContact} closeModal={() => setShowRemoveContact(false)}/>
            }
        </>
    );
}

export default ContactRow;